<template>
	<section id="gym" class="container gym">
		<img src="/img/icon-mats.jpg" alt="The training room and mats" class="photo" loading="lazy" />
		<div class="card info">
			<div class="about">
				<h2 class="cap title">The gym</h2>
				<p>150 m² of tatami, reception, and separate locker rooms with showers for women and men.</p>
			</div>
			<div class="address">
				<b>{{ contact.addressLine1 }}</b>
				<span>{{ contact.addressLine2 }}</span>
			</div>
			<a :href="contact.mapsUrl" class="btn directions" target="_blank" rel="noopener">Get directions</a>
		</div>
	</section>
</template>

<script>
import { contact } from "../../data/site.js";

export default {
	data() {
		return { contact };
	},
};
</script>

<style scoped>
.gym {
	padding-top: 40px;
	padding-bottom: 80px;
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
}

.photo {
	flex: 2 1 480px;
	min-width: 0;
	height: 360px;
	object-fit: cover;
	border-radius: var(--radius);
}

.info {
	flex: 1 1 300px;
	padding: 28px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 20px;
}

.about {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.title {
	font-size: 40px;
}

.about p {
	color: #3a3a3a;
}

.address {
	display: flex;
	flex-direction: column;
}

.directions {
	align-self: flex-start;
}

@media (max-width: 768px) {
	.gym {
		padding-top: 32px;
		padding-bottom: 0;
		flex-direction: column;
		gap: 10px;
	}

	.photo {
		flex: none;
		width: 100%;
		height: 220px;
	}

	.info {
		flex: none;
		padding: 20px;
		gap: 14px;
	}

	.title {
		font-size: 32px;
	}

	.about p {
		font-size: 15px;
	}

	.directions {
		align-self: stretch;
	}
}
</style>
